// extracted by mini-css-extract-plugin
export default {"navigation":"AdminNavigation_navigation__Y6S5+","menu":"AdminNavigation_menu__LO8PJ"};